module.exports = __webpack_public_path__ + "static/media/389094_0_0.714b72f3.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/helpers/webfonts/389094_0_0.eot
// module id = 713
// module chunks = 0